import { render } from "./ProjectBudgetBreakdown.vue?vue&type=template&id=a8d8b670"
import script from "./ProjectBudgetBreakdown.vue?vue&type=script&lang=js"
export * from "./ProjectBudgetBreakdown.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__